import React, { Component } from 'react';
import SvgPanZoom from 'svg-pan-zoom';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import Hammer from 'hammerjs';
import { t } from 'ttag'
/**
 * Svg pan for react.
 *
 * @version 1.0.0
 * @author [Nagy Gergely](https://github.com/gergely-nagy)
 */
class SvgViewer extends Component {
  constructor(props) {
    super(props);

    this.main_group_selector = ".svg-pan-zoom_viewport";
    this.myRef = React.createRef();
    this.timeoutRef = React.createRef();
    this.state = {
      r: 10,
      tooltipX: 0,
      tooltipY: 0,
      first: true,
      inputValue: 0,
      isAreaTooltipOpen: false,
      disableClick: false,
      notDisabled: true,
    };

    this.eventsHandler;
	this.limitPan;

    this.limitPan = (oldPan, newPan) => {
          let stopHorizontal = false
              , stopVertical = false
              , gutterWidth = 150
              , gutterHeight = 150
                // Computed variables
              , sizes = this.panZoomTiger.getSizes()
              , leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
              , rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom)
              , topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
              , bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)

            let customPan = {}
            customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
            customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))

            return customPan
    }



    this.eventsHandler = {
          haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel']
        , init: function(options) {
            var instance = options.instance
              , initialScale = 1
              , pannedX = 0
              , pannedY = 0

            // Init Hammer
            // Listen only for pointer and touch events
            this.hammer = Hammer(options.svgElement, {
              inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
            })

            // Enable pinch
            this.hammer.get('pinch').set({enable: true})

            // Handle double

            // Handle pan
            this.hammer.on('panstart panmove', function(ev){
              // On pan start reset panned variables
              if (ev.type === 'panstart') {
                pannedX = 0
                pannedY = 0
              }

              // Pan only the difference
              instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
              pannedX = ev.deltaX
              pannedY = ev.deltaY
            })

            // Handle pinch
            this.hammer.on('pinchstart pinchmove', function(ev){
              // On pinch start remember initial zoom
              if (ev.type === 'pinchstart') {
                initialScale = instance.getZoom()
                instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x - 50, y: ev.center.y - 200})
              }

              instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x - 50, y: ev.center.y - 200})
            })

            // Prevent moving the page on some devices when panning over SVG
            options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
          }

        , destroy: function(){
            this.hammer.destroy()
          }
        }

        if(!props.pinch) this.eventsHandler = null;
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.data !== prevProps.data) {
      this.panZoomTiger = SvgPanZoom(this.myRef.current, {
        zoomEnabled: this.props.zoomEnabled,
        dblClickZoomEnabled: false,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        maxZoom: 2.5,
		beforePan: this.limitPan,
        zoomScaleSensitivity: 0.25,
        onPan: this.handlePanOrZoom,
        onZoom: this.handlePanOrZoom,
        customEventsHandler: this.eventsHandler,
      });
      if (this.state.first) {
        this.panZoomTiger.zoomOut();
        this.panZoomTiger.setMinZoom(this.panZoomTiger.getZoom());
      }
      this.setState({
        first: false,
      });
    }
  }

  getSvgPoint = (x, y) => {
    // var svgDropPoint = document.querySelector('#svg-viewer').createSVGPoint();
    // alert(x)
    // alert(y)
    // alert(JSON.stringify(svgDropPoint))
    // svgDropPoint.x = x;
    // svgDropPoint.y = y;
    // svgDropPoint = svgDropPoint.matrixTransform(document.querySelector('.svg-pan-zoom_viewport').getCTM().inverse());
    // alert(JSON.stringify(svgDropPoint))
    // return svgDropPoint;
}

  componentDidMount() {
    if(this.props.fromAdmin){
      this.panZoomTiger = SvgPanZoom(this.myRef.current, {
        zoomEnabled: true,
        dblClickZoomEnabled: false,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        maxZoom: 2.5,
		beforePan: this.limitPan,
        zoomScaleSensitivity: 0.25,
        onPan: this.handlePanOrZoom,
        onZoom: this.handlePanOrZoom,
        customEventsHandler: this.eventsHandler,
      });

      if(this.props.twoColorMode) {
        this.setState({
          first: false,
        })
      }
      
      this.panZoomTiger.zoomOut();
      this.panZoomTiger.setMinZoom(this.panZoomTiger.getZoom());
    }

    //     this.eventsHandler = {
    //       haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel']
    //     , init: function(options) {
    //         var instance = options.instance
    //           , initialScale = 1
    //           , pannedX = 0
    //           , pannedY = 0

    //         // Init Hammer
    //         // Listen only for pointer and touch events
    //         this.hammer = new Hammer(options.svgElement, {
    //           inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
    //         })

    //         // Enable pinch
    //         this.hammer.get('pinch').set({enable: true})

    //         // Handle double tap
    //         this.hammer.on('doubletap', function(ev){
    //           instance.zoomIn()
    //         })

    //         // Handle pan
    //         this.hammer.on('panstart panmove', function(ev){
    //           // On pan start reset panned variables
    //           if (ev.type === 'panstart') {
    //             pannedX = 0
    //             pannedY = 0
    //           }

    //           // Pan only the difference
    //           instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
    //           pannedX = ev.deltaX
    //           pannedY = ev.deltaY
    //         })

    //         // Handle pinch
    //         this.hammer.on('pinchstart pinchmove', function(ev){
    //           // On pinch start remember initial zoom
    //           if (ev.type === 'pinchstart') {
    //             initialScale = instance.getZoom()
    //             instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
    //           }

    //           instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
    //         })

    //         // Prevent moving the page on some devices when panning over SVG
    //         options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
    //       }, destroy: function() {
    //         this.eventsHandler = null;
    //       }
    // }

    // this.panZoomTiger = SvgPanZoom('#svg-viewer', {
    //   zoomEnabled: true,
    //   dblClickZoomEnabled: false,
    //   controlIconsEnabled: false,
    //   fit: true,
    //   center: true,
    //   // customEventsHandler: this.eventsHandler
    // });
    // this.panZoomTiger.zoomOut();

  }

  handlePanOrZoom = () => {
    clearTimeout(this.timeoutRef.current);
    this.setState({ disableClick: true });
    this.timeoutRef.current = setTimeout(() => this.setState({ disableClick: false }), 500);
  }

  toggleTooltip = (x,y) => {
    this.setState({
      inputValue: 0,
      tooltipX: x,
      tooltipY: y
    }, () => {
      this.setState(prevState => ({ isAreaTooltipOpen: !prevState.isAreaTooltipOpen }));
    })
  }

  isValuesEmpty = (x, y) => {
    let result = false;

    if(!x || !y) result = true;

    return result;
  }

  handleClick() {
    this.setState({
        disabled: true,
    });

    if (this.state.disabled) {
        return;
    }

    setTimeout(() => this.setState({ disabled: false }), 2000);
}

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  renderSeats = (data, rowLabel, hasGroup, seatPrefix, seatSufix, blockPrefix) => {
    return data.map(e => (
      <g
        className={e.col && (e.col[1] || !this.isSectorUseable(e.sec) || ('rid' in e))  ? "seats-no" : "seats"}
        onClick={() => {
          this.setState({
            notDisabled: true,
          },);
    
          console.log('diasbled', this.state.disableClick, !this.state.notDisabled)
          if(this.state.disableClick || !this.state.notDisabled) return;
          if(this.props.pinch) {
            this.setState({ notDisabled: false }, () => { 
              setTimeout(() => this.setState({ notDisabled: true }), 300);
             });
          } 
          if(!e.col || (!e.col[1] && this.isSectorUseable(e.sec)) || ('rid' in e)) {
            this.setState({ isAreaTooltipOpen: false });
            this.props.onTicketClick(e, data, rowLabel, hasGroup, seatPrefix, seatSufix, blockPrefix);
          }
        }}
        onTouchEnd={() => {
          this.setState({
            notDisabled: true,
          });
          console.log('diasbled2', this.state.disableClick, !this.state.notDisabled)
          if(this.state.disableClick || !this.state.notDisabled) return;
          if(this.props.pinch) {
            this.setState({ notDisabled: false }, () => { 
              setTimeout(() => this.setState({ notDisabled: true }), 300);
             });
          } 
          if(!e.col || (!e.col[1] && this.isSectorUseable(e.sec))) {
            this.setState({ isAreaTooltipOpen: false });
            this.props.onTicketClick(e, data, rowLabel, hasGroup, seatPrefix, seatSufix, blockPrefix);
          }
        }}
      >
      {this.props.withSectorColors && (
        <circle
        cx={e.x}
        cy={e.y}
        r={this.state.r + 3}
        fill={
         this.getRingColorBySzektorId(e.sec, e.col)
        }
          // onClick={(event) => { event.preventDefault(); event.stopPropagation(); }}
        />
      )}
        <circle
          cx={e.x}
          cy={e.y}
          r={this.state.r}
          fill={
            this.props.aktivRendelesId && e.rid == this.props.aktivRendelesId ? 'yellow' : this.props.twoColorMode ? 
              (e.col && e.col[1] ?
                '#6e6e6e' :
                (e.new ? '#fac25a' : this.getColorBySzektorId(e.sec) )) :
              (e.res ?
                ('#' + this.props.szinek.cop) : e.new ? ('#' + this.props.szinek.con) : e.col ? '#' + e.col[0] :
                this.getColorBySzektorId(e.sec))
          }
          // onClick={(event) => { event.preventDefault(); event.stopPropagation(); }}
        />
        <text x={e.x} y={e.y} fill={this.props.aktivRendelesId && e.rid == this.props.aktivRendelesId ? 'black' : this.props.twoColorMode ? this.getCorrectTextColor(this.getColorBySzektorId(e.sec)) : (e.col ? this.getCorrectTextColor(e.col[0]) : this.getCorrectTextColor(this.getColorBySzektorId(e.sec)))} fontSize={10} dominantBaseline="middle" textAnchor="middle">{e.lab}</text>
      </g>
    ));
  }



  getColorBySzektorId = (id) => {
    let color = '3673bd';
    // TODO: DELETE 3rd condition
    if (Array.isArray(this.props.szektorok) && this.props.szektorok.length > 0 && id) color = this.props.szektorok.find(x => x.id === id).col;
    return '#' + color;
  }

  getRingColorBySzektorId = (id, col) => {
    let color = '3673bd';
    // TODO: DELETE 3rd condition
    if (Array.isArray(this.props.szektorok) && this.props.szektorok.length > 0 && id) color = this.props.szektorok.find(x => x.id === id).col;
    if(!id && col) {
      color = col[0]
    }
    return '#' + color;
  }

  isSectorUseable = (id) => {
    let useable = false;
    if(id) {
      if (Array.isArray(this.props.szektorok) && this.props.szektorok.length > 0) {
        useable = this.props.szektorok.find(x => x.id === id).use;
      }
    }
    return useable;
  }

  renderBlocks = (data, bix, bax) => {
    let blocks = [];
    data.forEach((e) => {
      if(e.seats && e.seats.length > 0) {
        if (!this.isValuesEmpty(e.blp[0], e.blp[1])) blocks.push(<text x={e.blp[0] - 20} y={e.blp[1]} fill="gray" fontSize={20} textAnchor="end" dominantBaseline="middle"><tspan>{e.lab}</tspan></text>);
        if (!this.isValuesEmpty(e.blp[2], e.blp[3])) blocks.push(<text x={e.blp[2] + 20} y={e.blp[3]} fill="gray" fontSize={20} textAnchor="start" dominantBaseline="middle"><tspan>{e.lab}</tspan></text>);
      }
      blocks.push(this.renderSeats(e.seats, e.lab, e.bsa, e.lsp, e.lss, e.lbp));
    });
    return blocks;
  }

  renderAreas = (data) => {
    return data.map(e => (
      <g
        transform={'rotate(' + e.rot + ' ' + e.x + ' ' + e.y + ')'}
        cursor={ (e.sec && e.cap > 0 && this.isSectorUseable(e.sec)) ? 'pointer' : 'not-allowed'}
        key={e.tid}
        onClick={(event) => {
          let svgpoint = this.getSvgPoint(event.clientX,event.clientY)
          if(e.sec && e.cap > 0 && this.isSectorUseable(e.sec)) {
            this.toggleTooltip(e.x - (e.wid/4),e.y + e.hei); 
          }
        }}
        onTouchEnd={() => {
          if(e.sec && e.cap > 0 && this.isSectorUseable(e.sec)) {
            this.toggleTooltip(e.x + 250, e.y); 
          }
        }}
      >
        <rect x={e.x - (e.wid / 2)} y={e.y - (e.hei / 2)} fill={e.sec ? this.getColorBySzektorId(e.sec) : "#405471" } height={e.hei} width={e.wid} rx={e.rad} ry={e.rad} />
        <text x={e.x} y={e.y} xmlSpace="preserve" fill="white" fontSize={e.las} dominantBaseline="middle" textAnchor="middle">{e.lab}</text>
      </g>
    ));
  }

  renderTexts = (data) => {
    if (data) return data.map(e => <text x={e.x} y={e.y} xmlSpace="preserve" transform={'rotate(' + e.rot + ' ' + e.x + ' ' + e.y + ')'} fill={'#' + e.col} fontSize={e.las} dominantBaseline="middle" textAnchor="middle"><tspan>{e.lab}</tspan></text>);
    return null;
  }

  renderVaszon = () => {
    return (
      <g>
        <rect x="310" y="-100" width="350" height="15" rx="5" ry="5" fill="url('#myGradient')" />
        <polygon points="310,-85 660,-85 760,-20 210,-20 " fill="url('#lgrad')" />
      </g>
    );
  }

  decreaseValue = () => {
    this.setState(prevState => ({ inputValue: (prevState.inputValue > 0) ? prevState.inputValue - 1 : 0 }));
  }

  incraseValue = () => {
    this.setState(prevState => ({ inputValue: prevState.inputValue + 1 }));
  }


  render() {
    const areas = this.renderAreas(this.props.data.areas);
    const blocks = this.renderBlocks(this.props.data.blocks, this.props.data.bix, this.props.data.bax);
    const texts = this.renderTexts(this.props.data.texts);
    return (
      <React.Fragment>
        <svg
          id={this.props.id}
          height={this.props.height}
          width="100%"
          onMouseDown={(event) => { event.preventDefault(); }}
          onMouseMove={(event) => { event.preventDefault(); }}
          ref={this.myRef}
        >
          <defs>
            <radialGradient id="myGradient">
              <stop offset="10%" stopColor="#3e87cd" />
              <stop offset="130%" stopColor="#3673bd" />
            </radialGradient>
            <linearGradient id="lgrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="20%" style={{ stopColor: '#192c43', stopOpacity: 0.9 }} />
              <stop offset="100%" style={{ stopColor: '#192c43', stopOpacity: 0 }} />
            </linearGradient>
          </defs>
          <g
            onKeyDown={this.props.onKeyDown}
            onKeyUp={this.props.onKeyUp}
          >
            {areas}
            {blocks}
            {texts}
            {this.state.isAreaTooltipOpen && (
              <foreignObject x={this.state.tooltipX.toString()} y={this.state.tooltipY.toString()} width="200" height="170">
                <div xmlns="http://www.w3.org/1999/xhtml" className="wrapper" style={{ background: 'rgb(43, 43, 43)', margin: 0 }}>
                  <div className="row" style={{ margin: 0, padding :10, textAlign: 'center' }}>
                    <div className="col-12" style={{ textAlign: 'center' }} >
                      {'Standard állóhely'}
                    </div>
                    <div className="col-12" style={{ textAlign: 'center', paddingBottom: 5 }} >
                      {'1200 Ft'}
                    </div>
                    <div className="col-2" style={{ cursor: 'pointer' }} onClick={this.decreaseValue}>
                      <span className="">-</span>
                    </div>
                    <div className="col-8">
                      {this.state.inputValue}{' db'}
                    </div>
                    <div className="col-2" style={{ cursor: 'pointer' }}  onClick={this.incraseValue}>
                      <span className="">+</span>
                    </div>
                    <div className="col-12" style={{ textAlign: 'center', paddingTop: 10 }} >
                      <Button
                        size="sm"
                        color="primary"
                        block
                        onClick={() => { this.toggleTooltip(0,0); }}
                      >
                        {'Alkalmaz'}
                      </Button>
                    </div>
                  </div>
                </div>
              </foreignObject>
            )}
          </g>
          {/* this.renderVaszon() */}
        </svg>
        <br></br>
        { this.props.isButtonsActive && (
          <div style={{ marginTop: 20 }}>
            {' '}
            <Button
              onClick={() => {
                this.panZoomTiger.reset();
                this.panZoomTiger.zoomOut();
              }}
            >
              { t`Alapnézet` }
            </Button>
            {' '}
            <Button
              onClick={() => { this.panZoomTiger.zoomIn(); }}
            >
              {'+'}
            </Button>
            {' '}
            <Button
              onClick={() => { this.panZoomTiger.zoomOut(); }}
            >
              {'-'}
            </Button>
          </div>
        )
        }
      </React.Fragment>
    );
  }
}

SvgViewer.propTypes = {
  id: PropTypes.string,
  szinek: PropTypes.object,
  szektorok: PropTypes.array,
  height: PropTypes.string,
  data: PropTypes.object,
  bix: PropTypes.number,
  bax: PropTypes.number,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onAreaClick: PropTypes.func,
  zoomEnabled: PropTypes.bool,
  withSectorColors: PropTypes.bool,
  isButtonsActive: PropTypes.bool,
  twoColorMode: PropTypes.bool,
  pinch: PropTypes.bool,
};

// Specifies the default values for props:
SvgViewer.defaultProps = {
  id: 'svg-viewer',
  height: '320px',
  zoomEnabled: true,
  withSectorColors: false,
  isButtonsActive: true,
  twoColorMode: false,
  pinch: false,
  // onAreaClick: () => {},
  // onKeyUp: () => {}
};

export default SvgViewer;
